import type { TFunction } from 'i18next';

const CODE_TO_KEY: Record<number, string> = {
  [-2]: 'common:errors.unknownError',
  [-3]: 'common:errors.parameterInvalid',
  [-5]: 'common:errors.noSuchUser',
  [-6]: 'common:errors.passwordError',
  [-7]: 'common:errors.tokenError',
  [-8]: 'common:errors.passwordNotMatch',
  [-9]: 'common:errors.emailAlreadyExists',
  [-10]: 'common:errors.passwordNotStrong',
  [-11]: 'common:errors.emailCodeError',
  [-12]: 'common:errors.emailCodeNotFound',
  [-13]: 'common:errors.emailCodeExpired',
  [-14]: 'common:errors.emailAlreadyVerified',
  [-15]: 'common:errors.emailCodeRateLimited',
  [-16]: 'common:errors.twoFactorRequired',
  [-17]: 'common:errors.twoFactorInvalid',
  [-18]: 'common:errors.twoFactorAlreadyEnabled',
  [-19]: 'common:errors.twoFactorNotEnabled',
  [-20]: 'common:errors.captchaRequired',
  [-21]: 'common:errors.captchaNotFound',
  [-22]: 'common:errors.captchaExpired',
  [-23]: 'common:errors.captchaInvalid',
  [-30]: 'common:errors.orderNotFound',
  [-32]: 'common:errors.orderAlreadyPaid',
  [-33]: 'common:errors.orderExpired',
  [-34]: 'common:errors.userEmailNotExist',
  [-40]: 'common:errors.dataNotExists',
  [-41]: 'common:errors.balanceInsufficient',
  [-50]: 'common:errors.emailSendFailed',
  [-60]: 'common:errors.authenticationRequired',
  [-61]: 'common:errors.adminAccessRequired',
  [-70]: 'common:errors.apiKeyRequired',
  [-71]: 'common:errors.apiKeyInvalid',
  [-80]: 'common:errors.serviceNotConfigured',
};

type ApiErrorLike = {
  code?: number | string;
  response?: { data?: ApiErrorLike };
};

function errorCode(input: ApiErrorLike | null | undefined): number | null {
  const payload = input?.response?.data ?? input;
  if (typeof payload?.code === 'number') return payload.code;
  if (typeof payload?.code === 'string') {
    const parsed = Number(payload.code);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

export function getApiErrorMessage(
  input: ApiErrorLike | null | undefined,
  t: TFunction,
  fallbackKey = 'common:errors.operationFailed',
): string {
  const code = errorCode(input);
  const key = code == null ? null : CODE_TO_KEY[code];
  return key ? t(key) : t(fallbackKey);
}
